module.exports = __webpack_public_path__ + "img/mile4m-m@1.ef06d912.jpg";